import { OrderRequest } from "../../hooks/useOrder";
import { Loader } from "../Loader";
import { OrderDetails } from "./OrderDetails";

export type OrderInfoProps = OrderRequest & {
  admin: boolean;
  showViewShipmentBtn?: boolean;
  showCreateShipmentBtn?: boolean;
  showViewOrderBtn?: boolean;
  showItems?: boolean;
  showOriginalItems?: boolean;
  showShipmentItems?: boolean;
};
export function OrderInfo({
  order,
  status,
  orderSlug,
  error,
  admin,
  shipmentsRequest,
  showCreateShipmentBtn,
  showViewShipmentBtn,
  showItems,
  showShipmentItems,
  showViewOrderBtn,
}: OrderInfoProps) {
  return status === "loading" ? (
    <div>
      <div>Order #{order?.slug}</div>
      <div>
        <Loader type="text" showDots>
          Loading order data
        </Loader>
      </div>
    </div>
  ) : status === "present" && order ? (
    <OrderDetails
      showViewShipmentBtn={showViewShipmentBtn}
      showCreateShipmentBtn={showCreateShipmentBtn}
      shipmentsRequest={shipmentsRequest}
      showViewOrderBtn={showViewOrderBtn}
      showItems={showItems}
      showShipmentItems={showShipmentItems}
      order={order}
      admin={admin}
    />
  ) : (
    <div>
      {orderSlug}
      {status}
      {typeof error === "string" ? error : JSON.stringify(error)}
    </div>
  );
}
